import React, { useState, useEffect, useRef } from 'react';
import { FaBell, FaUserCircle, FaSignOutAlt, FaEdit } from 'react-icons/fa';
import axios from 'axios';
import UserPhoto from '../../Assets/images/UserPhoto.png';
import Logo from '../../Assets/images/Frame 39059 1.png';
import NotificationPhoto from '../../Assets/images/NotificationPhoto.png';
import { useNavigate } from 'react-router-dom';
import MyProfile from './MyProfile';
import { API_BASE_URL } from '../../config';
function useOutsideClick(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, callback]);
}

const DashBoardHeader = ({ onLogout }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(null);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [userProfile, setUserProfile] = useState(null); // Store user profile data

  const navigate = useNavigate();
  const notificationRef = useRef(null);
  const userInfoRef = useRef(null);

  useOutsideClick(notificationRef, () => setIsPopupVisible(false));

  //  const handleLoginClick = () => navigate('/login');
  useOutsideClick(userInfoRef, () => {
    setShowUserProfile(false);
    setShowProfile(false);
  });

  const togglePopup = () => {
    setIsPopupVisible(prev => !prev);
  };

  // get notification api
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/account/notification/`,
        // 'https://finwise-backend.vercel.app/account/notification/',
        // 'https://finwiseback.finwise.com.bd/account/notification/',
        // 'http://127.0.0.1:8000/account/notification/',
        {
          // headers: {
          //   Cookie:
          //     'csrftoken=lgcs2QC0IaxcCeeVoYEOw9IlT5Dvo0r9; sessionid=bxyh6gm0sh7o08bms9h3eqgu6gt80weo',
          //   'X-CSRFToken': 'lgcs2QC0IaxcCeeVoYEOw9IlT5Dvo0r9',
          // },
          withCredentials: true,
        }
      );
      // console.log('Notification:', response.data);
      setNotifications(response.data);
    } catch (error) {
      setError('Error fetching notifications');
    }
  };

  // Use effect to fetch notifications every second
  useEffect(() => {
    const interval = setInterval(() => {
      fetchNotifications();
    }, 1000); // Fetch notifications every 1 second

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  // get user api
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/user-profile/`,
          // 'https://finwise-backend.vercel.app/account/user-profile/',
          // 'https://finwiseback.finwise.com.bd/account/user-profile/',
          // 'http://127.0.0.1:8000/account/user-profile/',
          {
            // headers: {
            //   Cookie:
            //     'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
            // },
            withCredentials: true,
          }
        );
        setUserProfile(response.data); // Store profile data
        // setLoading(false);
      } catch (error) {
        setError('Failed to fetch profile data');
        // setLoading(false);
      }
    };

    fetchProfileData();
    
        const interval = setInterval(() => {
          fetchProfileData();
        }, 1000); // Fetch notifications every 1 second
        return () => clearInterval(interval); 
  }, []);

  const handleHomeNavigate = () => {
    navigate('/dashboard');
  };

  // const handleNewLoanApplication = () => {
  //   navigate('/upas');
  // };
  const handleNewLoanApplication = () => {
    navigate('/NewLoanApplication');
  };
  const handleProfileEditClick = () => {
    navigate('/profileDetails');
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  // const confirmLogout = () => {
  //   setShowLogoutModal(false);
  //   onLogout();
  //   // logout();
  // };

  const confirmLogout = async () => {
    setShowLogoutModal(false);
    try {
      const headers = {
        'Content-Type': 'application/json',
        Cookie:
          'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
      };

      const response = await axios.post(
        `${API_BASE_URL}/account/logout/`,
        // 'https://finwise-backend.vercel.app/account/logout/',
        // 'https://finwiseback.finwise.com.bd/account/logout/',
        // 'http://127.0.0.1:8000/account/logout/',
        {},
        {
          headers: headers,
          withCredentials: true,
        }
      );

      // localStorage.removeItem('userMobile');
      // localStorage.removeItem('password');
      // localStorage.removeItem('selectedRole');
      // sessionStorage.removeItem('userMobile');
      // sessionStorage.removeItem('password');
      // sessionStorage.removeItem('selectedRole');

      // Perform additional logout actions if necessary
      navigate('/login'); // Redirect to login page after logout

      console.log('Logout successful:', response.data);
      onLogout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleProfileClick = () => {
    setShowProfile(!showProfile);
  };

  const toggleLogout = () => {
    setShowUserProfile(!showUserProfile);
  };

  // const togglePopup = () => {
  //   setIsPopupVisible(!isPopupVisible);
  // };

  const handleCloseProfile = () => {
    setShowProfile(false);
  };

  return (
    <div className="relative">
      <div className="flex items-center justify-between bg-white shadow-md px-1 py-3 md:px-6 relative z-20">
        <div className="flex items-center">
          <button onClick={handleHomeNavigate}>
            <img src={Logo} alt="Logo" className="md:h-14 h-9 w-auto" />
          </button>
        </div>

        <div className="flex items-center lg:space-x-10 space-x-3">
          {/* <button
            onClick={handleNewLoanApplication}
            className="bg-headerBtn md:text-sm text-[10px] text-white md:py-2 md:px-2 py-2 px-1.5 md:ml-0 ml-4 rounded-md hover:bg-btnHover transition duration-200"
          >
            New UPAS/LC Application
          </button> */}

          {/* notifications */}
          <div className="relative mt-1" ref={notificationRef}>
            <button
              className="text-headerBtn hover:text-btnHover focus:outline-none"
              onClick={togglePopup}
            >
              <FaBell size={20} />
            </button>

            {isPopupVisible && (
              <div className="absolute -right-10 md:-right-16 mt-4 lg:w-96 w-72 bg-white border border-gray-200 shadow-xl rounded-md p-4 text-sm z-30  overflow-y-auto max-h-96 ">
                <h2 className="text-center text-lg font-bold mb-2">
                  Notifications ({notifications.length})
                </h2>
                {notifications.length > 0 ? (
                  notifications.map((notification, index) => (
                    <div
                      key={index}
                      className=" flex items-center space-x-2 border-2 bg-NotificationBg p-2 mb-1 "
                    >
                      <img
                        // src={notification.photoUrl || NotificationPhoto}
                        src={
                          notification?.photoUrl
                            ? `${API_BASE_URL}${notification.photoUrl}`
                            : ''
                        }
                        alt="Notification Photo"
                        className="lg:h-12 lg:w-12 h-14 w-14 rounded-full"
                      />
                      <div className="text-black text-xs">
                        <p>{notification.message}.</p>
                        <small className="text-gray-500 flex items-start justify-start ">
                          {new Date(notification.created_at).toLocaleString()}
                          {/* Format the date */}
                        </small>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No new notifications</p>
                )}
              </div>
            )}
          </div>

          {/* user info */}
          <div
            className="relative border border-headerBtn p-1 rounded-md lg:w-64 "
            ref={userInfoRef}
          >
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={toggleLogout}
            >
              <img
                // src={userProfile ? userProfile.company_logo : 'User Photo'}
                // src={userProfile?.company_logo || UserPhoto}
                src={
                  userProfile?.company_logo
                    ? `${API_BASE_URL}${userProfile.company_logo}`
                    : ''
                }
                // alt="User Photo"
                className="lg:h-10 lg:w-10 h-8 w-8 rounded-full"
              />
              <span className="text-headerBtn text-center md:text-lg font-semibold text-xs hidden md:block">
                {userProfile ? userProfile.company_name : 'User'}
                {/* Display user profile name */}
              </span>
            </div>

            {showUserProfile && (
              <div className="absolute right-0 mt-3 lg:w-64 w-48 bg-white shadow-lg  p-0 text-sm z-30 border border-headerBtn rounded-md lg:text-lg font-semibold">
                <div
                  className="flex items-center gap-2 mb-2 cursor-pointer hover:bg-gray-100 p-2 rounded border-b border-headerBtn"
                  onClick={handleProfileClick}
                >
                  <FaUserCircle className="text-headerBtn" />
                  <span className="text-headerBtn">My Profile</span>
                </div>
                <div
                  className="flex items-center gap-2 mb-2 cursor-pointer hover:bg-gray-100 p-2 rounded border-b border-headerBtn"
                  onClick={handleProfileEditClick}
                >
                  <FaEdit className="text-headerBtn" />
                  <span className="text-headerBtn">Edit Profile</span>
                </div>
                <div className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 p-2 rounded ">
                  <button
                    className="flex gap-2 text-headerBtn"
                    onClick={handleLogoutClick}
                  >
                    <FaSignOutAlt className="text-headerBtn mt-1" />
                    Logout
                  </button>
                  {showLogoutModal && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 md:px-0 px-10">
                      <div className="bg-AboutUsBg md:p-6 p-4 rounded-lg shadow-lg">
                        <h2 className="md:text-lg text-sm font-bold md:mb-4 mb-2">
                          Are you sure you want to logout?
                        </h2>
                        <div className="flex justify-center space-x-4">
                          <button
                            onClick={confirmLogout}
                            className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
                          >
                            Yes
                          </button>
                          <button
                            onClick={cancelLogout}
                            className="bg-headerBtn text-white py-2 px-6 rounded-lg hover:bg-gray-600"
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {showProfile && (
                  <div className="absolute md:-left-[406px] -left-[140px] md:-mt-32 -mt-12 h-10">
                    <MyProfile onClose={handleCloseProfile} />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoardHeader;
